<template>
  <header class="header-ruby">
    <h1>SDGsマスター</h1>
    <h2>
      <ruby>持続可能<rt>じぞくかのう</rt></ruby> な
      <ruby>開発目標<rt>かいはつもくひょう</rt></ruby
      >を<br />
      <ruby>楽<rt>たの</rt></ruby
      >しく<ruby>学<rt>まな</rt></ruby
      >ぼう！
    </h2>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
};
</script>

<style scoped>
/* 必要に応じてスタイルを追加 */
</style>
